// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"4655cdd0","624":"4655cdd0"}[chunkId] + ".css";
};